import { useEffect, useRef } from 'react';
import { Alert, AppState, AppStateStatus, Platform } from 'react-native';
import * as Updates from 'expo-updates';

const useUpdatesChecker = () => {
  const appState = useRef(AppState.currentState);

  useEffect(() => {
    if (Platform.OS !== 'web') {
      const listener = AppState.addEventListener('change', handleAppStateChange);
      checkForUpdates();

      return () => {
        listener.remove();
      };
    }
    return () => {};
  }, []);

  const checkForUpdates = async () => {
    const res = await Updates.checkForUpdateAsync();
    if (res.isAvailable) {
      const resFetch = await Updates.fetchUpdateAsync();
      if (resFetch.isNew) {
        Alert.alert(
          'Mise à jour',
          "Une mise à jour est disponible. L'application va être relancée.\n" +
            "Si vous annulez cette action, pensez à relancer l'application vous même.",
          [
            { text: 'OK', onPress: () => Updates.reloadAsync() },
            { text: 'Annuler', style: 'cancel', onPress: () => {} },
          ],
          { cancelable: true }
        );
      }
    }
    await Updates.fetchUpdateAsync();
  };

  const handleAppStateChange = async (nextAppState: AppStateStatus) => {
    if (appState.current.match(/inactive|background/) && nextAppState === 'active') {
      await checkForUpdates();
    }

    appState.current = nextAppState;
  };
};

export default useUpdatesChecker;
